module.exports = __webpack_public_path__ + "img/info.6ec9e4c2.svg";